import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        onClose: '&',
        onUpdate: '&',
        competenceSkill: '<'
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.onClose()"></button>
            <h2>{{ 'user.Edit skill' | translate }}</h2>
        </div>
        <form ng-submit="vm.save()" class="form">
            <div class="modal-body">
                <form-wrapper form="vm.form">
                    <form-row error="vm.form.errors.name">
                        <label class="label">{{ 'user.Skill name' | translate }} *</label>
                        <div class="items"><span class="text">{{ vm.competenceSkill.skill.name }}</span></div>
                    </form-row>
                    <form-row error="vm.form.errors.skills[key].type">
                        <span class="label">{{ 'user.Skill type' | translate }}</span>
                        <div class="items">
                            <ul class="checkboxes">
                                <li>
                                    <label><input
                                     ng-model="vm.form.model.type"
                                     type="radio"
                                     value="{{ vm.USER_COMPETENCE_SKILL_TYPE_ENUM.KEYS.MANDATORY }}"> {{ vm.USER_COMPETENCE_SKILL_TYPE_ENUM.LABELS.MANDATORY }}
                                      </label>
                                    <label><input
                                         ng-model="vm.form.model.type"
                                         type="radio"
                                         value="{{ vm.USER_COMPETENCE_SKILL_TYPE_ENUM.KEYS.OPTIONAL }}"> {{ vm.USER_COMPETENCE_SKILL_TYPE_ENUM.LABELS.OPTIONAL }}</label>
                                </li>
                                <form-row-error></form-row-error>
                            </ul>
                        </div>
                    </form-row>
                </form-wrapper>
            </div>
            <div class="modal-footer" >
                    <ul class="actions01">
                        <li class="primary">
                            <button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Save' | translate }}</button>
                        </li>
                        <li class="primary">
                            <button class="btn negative" type="button" ng-click="vm.delete()">{{ 'general.Delete' | translate }}</button>
                        </li>
                        <li>
                            <button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()">{{ 'general.Cancel' | translate }}</button>
                        </li>
                    </ul>
                </div>
        </form>
    `
})
export default class {
    constructor (FormFactory, CompetenceResource, USER_COMPETENCE_SKILL_TYPE_ENUM) {
        this.FormFactory = FormFactory;
        this.CompetenceResource = CompetenceResource;
        this.USER_COMPETENCE_SKILL_TYPE_ENUM = USER_COMPETENCE_SKILL_TYPE_ENUM;
    }

    $onInit () {
        this.form = this.FormFactory.createFromResource(this.competenceSkill);
    }

    save () {
        return this.CompetenceResource.updateSkill(this.form.model).$promise.then((updatedSkill) => {
            return this.onUpdate({ updatedSkill });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/competence/competence/editSkill/index.js